export const GET_BIOCHAR_PRODUCTION_SUCCESS = 'GET_BIOCHAR_PRODUCTION_SUCCESS';
export const GET_BIOCHAR_PRODUCTION_FAIL = 'GET_BIOCHAR_PRODUCTION_FAIL';

export const GET_FEEDSTOCK_DELIVERED_SUCCESS = 'GET_FEEDSTOCK_DELIVERED_SUCCESS';
export const GET_FEEDSTOCK_DELIVERED_FAIL = 'GET_FEEDSTOCK_DELIVERED_FAIL';